import { lazyLoad } from 'app/utils/loadable';

export const Tickets = lazyLoad(
  () => import('./tickets'),
  (module) => module.Tickets
);
